import { render, staticRenderFns } from "./left-center.vue?vue&type=template&id=905c2972&"
import script from "./left-center.vue?vue&type=script&lang=js&"
export * from "./left-center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports